import PubSub from "underpub-js";

var TrimWave = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-TrimWave',
	};

	$.extend(true, this.options, options);

};

TrimWave.prototype.init = function() {

	var self = this;

};

export default TrimWave;
